/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import template from './political-entity-campaigns-panel.component.html';
import {formatAdnStat} from '../common/filters/format-adn-stat';
import {AppLocaleService} from '../common/locale/app-locale.service';
import {PoliticalCampaignResource} from '../../components/api/resources/resource/political-campaign.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-political-entity-campaigns-panel',
  template
})
export class PoliticalEntityCampaignsPanelComponent implements OnInit, OnChanges {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;

  effectiveIsNew = false;
  campaignPage: any;

  private subscriberRegistered = false;

  constructor(
    @Inject(PoliticalCampaignResource) private readonly PoliticalCampaign: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {}

  ngOnInit(): void {
    this.effectiveIsNew = !!this.isNew;
    this.registerSubscriber();
    this.tryLoadCampaigns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.model && !changes.model.firstChange) {
      this.tryLoadCampaigns();
    }
  }

  formatStat(value: any): string {
    return formatAdnStat(value, undefined, undefined, undefined, this.LocalNetworkProfile.get('defaultCurrency'), this.appLocale.getLocaleId());
  }

  trackById(_: number, item: any): string {
    return item.id;
  }

  private registerSubscriber(): void {
    if (!this.modelComms || this.subscriberRegistered) {
      return;
    }
    this.subscriberRegistered = true;
    // Route isNew never flips after save; modelComms does.
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms?: boolean) => {
      if (type || !data || !data.id) {
        return;
      }
      if (isNewFromComms === true || isNewFromComms === false) {
        this.effectiveIsNew = isNewFromComms;
      } else if (data?.name) {
        this.effectiveIsNew = false;
      }
      if (!this.effectiveIsNew) {
        this.loadCampaigns(data.id);
      }
    });
  }

  private tryLoadCampaigns(): void {
    if (!this.effectiveIsNew && this.model?.id) {
      this.loadCampaigns(this.model.id);
    }
  }

  private loadCampaigns(entityId: string): void {
    this.campaignPage = this.PoliticalCampaign.query({
      politicalEntity: entityId,
      pageSize: 2000
    });
  }
}
